import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { convertNumber } from 'helpers/utils';
import { useDebounce } from 'hooks/useDebounce';

import { Client } from 'store/client/actions';
import { clientListSelector } from 'store/client/selectors';

import { Portal } from 'components/Portal';
import { Icon } from 'components/Icon';
import { Loader } from 'components/Loader';
import { InputIcon } from 'components/Input';
import { ButtonIcon } from 'components/Button';
import ReactTooltip from 'react-tooltip';

import './style.scss';
import { errorToast } from 'configuration/notifications';

const ModalClientDuplication = ({ historyParams, INN, onSubmit, onClose }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const clientList = useSelector(clientListSelector);

  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState();

  const debouncedSearch = useDebounce(search, 500, true);

  useEffect(() => {
    clientsList();
  }, [debouncedSearch]);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  const clientsList = () => {
    const query = { INN };
    if (!search) {
      query.limit = 10;
    } else {
      query.individual = true;
      query.search = search;
    }
    dispatch(Client.getClientList(query));
  };

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSelectUser = (client) => {
    if (client.isPendingDeletion) {
      errorToast('Данный клиент помечен на удаление!');
    }
    return !client.isPendingDeletion && setSelectedUser(client);
  };

  const handleClient = (client) => {
    window.open(`${window.location.origin}/client/${client.id}`, '_blank');
  };

  const handleSubmitUser = () => {
    return selectedUser && onSubmit(selectedUser);
  };

  return (
    <Portal id="modal-client" className="contragent" onClose={onClose}>
      <div className="modal-title modal-duplication">
        <div className="header-title">Контрагенты c совпадающим ИНН</div>
        <div className="header-text">
          Выбирите контрагента, который будет обновлен реквизитами из Дія и которому добавится документ.
        </div>
      </div>

      <InputIcon icon="search" onChange={handleSearch} value={search} placeholder="ФИО или номер" />

      <div className="contragent-list dropdownScroll">
        {clientList &&
          clientList.map((client) => (
            <div
              key={client.id}
              className={`contragent-item ${selectedUser?.id === client.id ? 'is-selected' : ''}`}
              onClick={() => handleSelectUser(client)}
            >
              <div>
                <div className="contragent-select">
                  <Icon
                    name={
                      client.isPendingDeletion
                        ? 'userverify-pending-deletition'
                        : client.isTemporary
                        ? 'userverify-yellow'
                        : 'userverify'
                    }
                  />
                  <div className="contragent-data">{client.FIO}</div>
                </div>

                <div className="contragent-select">
                  <Icon name="modalphone" />
                  <div className="contragent-data">{convertNumber(client.PhMain)}</div>
                </div>

                {client.PhAdd && (
                  <div className="contragent-select">
                    <Icon name="modalphone" />
                    <div className="contragent-data">{convertNumber(client.PhAdd)}</div>
                  </div>
                )}
              </div>

              <div
                className="button-case"
                onClick={() => handleClient(client)}
                data-tip
                data-for="client-profile-tooltip"
              >
                <Icon name="usercard" />
              </div>
            </div>
          ))}

        {clientList === null && <Loader type="small" color="#000" />}
      </div>

      <div className="flex-center">
        <ButtonIcon
          className="btn-modal btn-client-modal"
          onClick={handleSubmitUser}
          disabled={selectedUser === null}
          icon="client-btn"
          text="Выбрать клиента"
        />
        <ReactTooltip place="left" id="client-profile-tooltip">
          Профиль клиенка
        </ReactTooltip>
      </div>
    </Portal>
  );
};

ModalClientDuplication.propTypes = {
  historyParams: PropTypes.object,
  INN: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

ModalClientDuplication.defaultProps = {
  historyParams: {},
  onSubmit: () => {},
};

export { ModalClientDuplication };
